import ApiConfig from '../../config/api'

import BaseListModel from './BaseListModel'

export default class MachineModel extends BaseListModel {
  apiUrl = ApiConfig.api.machine.machine_list
}

export const machineStore = new MachineModel()
